import React, { useContext } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { AppState } from '../../store'
import Template from '../../components/Template'
import Recovery from '../../components/Recovery'
import { Patient } from '../../api/patient.types'
import { recoverySendPasswordRequestAction } from '../../store/reducks/recovery/recovery.send_password.actions'
import { recoverySendSmsRequestAction } from '../../store/reducks/recovery/recovery.send_sms.actions'
import { recoveryCheckCodeRequestAction } from '../../store/reducks/recovery/recovery.check_code.actions'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import './style.less'
import { patientsByphoneMainRequest } from '../../store/reducks/patients/patients.byphone.main.actions'
import { smart_captcha } from '../../tools/smart-captcha'
import { emitter, IConfirmDto } from '../../store/reducks/chat/chat.session'
import { AuthConfigContext } from '../../components/AuthConfigProvider'

export type RecoveryViewProps = ReduxConnectedProps & RouteComponentProps & { isSms?: boolean }

export type RecoveryViewState = {
  stage: 'STEP1' | 'STEP2' | 'STEP3' | 'STEP1_ERR'
  phone?: string
  code?: string
  medic_user_id?: number
}

class RecoveryView extends React.Component<RecoveryViewProps, RecoveryViewState> {
  constructor(props: RecoveryViewProps) {
    super(props)
    this.state = {
      stage: 'STEP1',
      phone: props.user.phone,
    }
    this.props.patientsByphoneMainRequest()
  }

  componentDidMount() {
    emitter.on('confirmed', this.onConfirmed)
  }

  componentDidUpdate(prevProps: RecoveryViewProps) {
    smart_captcha.show()
    const { sendPassword, sendSms, checkCode } = this.props
    if (!sendPassword.fetching && prevProps.sendPassword.fetching && !sendPassword.error) {
      this.props.history.goBack()
    }
    if (!sendSms.fetching && prevProps.sendSms.fetching && !sendSms.error) {
      this.setState({ stage: 'STEP2' })
    }
    if (!checkCode.fetching && prevProps.checkCode.fetching && !checkCode.error) {
      this.setState({ stage: 'STEP3' })
    }
    const isSessionError = (sendSms: any) => sendSms.error && sendSms.errorData?.code == 'WAITCALL_ERROR_1'
    if (isSessionError(sendSms) && !isSessionError(prevProps.sendSms)) {
      this.setState({ stage: 'STEP1_ERR' })
    }
  }

  componentWillUnmount(): void {
    emitter.off('confirmed', this.onConfirmed)
    smart_captcha.hide()
  }

  private onConfirmed = (data: IConfirmDto) => {
    this.onCodeSubmit(data.wait_phone)
  }

  private renderStep1 = () => {
    const phone = this.state.phone as string
    return <Recovery.Step1
      phone={phone}
      disabled={this.fetching()}
      onSubmit={this.onPhoneSubmit}
    />
  }

  private renderStep1Err = () => {
    const { sendSms } = this.props;
    const expireAt = sendSms.errorData?.expire_at
    return <Recovery.Step1Err
      expireAt={expireAt}
      onTimeout={() => this.setState({ stage: 'STEP1' })}
      onBack={() => this.setState({ stage: 'STEP1' })}
    />
  }

  private fetching = () => {
    const { sendSms, checkCode, sendPassword } = this.props
    return sendSms.fetching || checkCode.fetching || sendPassword.fetching
  }

  private onPhoneSubmit = () => {
    const { phone } = this.state
    this.props.recoverySendSmsRequestAction({
      phone: phone as string,
    })
  }

  private renderStep2 = () => {
    const { phone } = this.state
    const { checkCode, sendSms, isSms } = this.props
    const step2 = <Recovery.Step2
      phone={phone as string}
      onCodeSubmit={this.onCodeSubmit}
      codeError={checkCode.error ? 'Неверный код' : undefined}
      phoneDisabled={this.fetching()} // TODO
      onPhoneSubmit={this.onPhoneSubmit}
    />
    if (isSms || !sendSms.waitPhone) {
      return step2;
    }
    const step2Call = <Recovery.Step2Call
      waitPhone={sendSms.waitPhone}
      expireAt={sendSms.expireAt}
    />
    return step2Call
  }

  private onCodeSubmit = (code: string) => {
    this.setState({ code }, () => {
      const { phone } = this.state
      this.props.recoveryCheckCodeRequestAction({
        phone: phone as string,
        code,
      })
    })
  }

  private renderStep3 = () => {
    const { checkCode: code } = this.props
    return <Recovery.Step3
      patients={code.patients}
      onPatientSelect={this.onPatientSelect}
    />
  }

  private onPatientSelect = (patient: Patient) => {
    const { medic_user_id } = patient
    this.setState({ medic_user_id }, () => {
      const { code, phone } = this.state
      this.props.recoverySendPasswordRequestAction({
        phone: phone as string,
        code: code as string,
        medic_user_id,
      })
    })
  }

  private renderHeader = () => {
    return <Recovery.Header
      title={this.getHeaderTitle()}
      onBack={this.onBack}
    />
  }

  private getHeaderTitle = () => {
    const { stage } = this.state
    switch (stage) {
      case 'STEP1':
      case 'STEP2':
        return 'Восстановление пароля медкарты'
      case 'STEP1_ERR':
        return 'Ошибка восстановление пароля'
      case 'STEP3':
      default:
        return 'Чей пароль вы хотите восстановить?'
    }
  }

  private onBack = () => {
    const { stage } = this.state
    switch (stage) {
      case 'STEP1':
        this.props.history.goBack()
        break;
      case 'STEP1_ERR':
      case 'STEP2':
        this.setState({ stage: 'STEP1' })
        break;
      case 'STEP3':
        this.setState({ stage: 'STEP2' })
        break;
      default:
        return
    }
  }

  render() {
    const { stage } = this.state
    return <Template
      className="recovery"
      title={this.getHeaderTitle()}
      onTitleBack={this.onBack}
      sidebar={<div className="sidebar-default"/>}
    >
      <div className="recovery-steps">
        {stage == 'STEP1' && this.renderStep1()}
        {stage == 'STEP2' && this.renderStep2()}
        {stage == 'STEP3' && this.renderStep3()}
        {stage == 'STEP1_ERR' && this.renderStep1Err()}
      </div>
    </Template>
  }
}

const connector = connect(
  (state: AppState) => ({
    sendSms: state.recovery.sendSms,
    checkCode: state.recovery.checkCode,
    sendPassword: state.recovery.sendPassword,
    path: state.recovery.view.path || '/medcard',
    user: state.user,
  }), {
  recoverySendPasswordRequestAction,
  recoverySendSmsRequestAction,
  recoveryCheckCodeRequestAction,

  patientsByphoneMainRequest,
})


type ReduxConnectedProps = ConnectedProps<typeof connector>

const _RecoveryView = (props: any) => {
  const recovery = useContext(AuthConfigContext)
  return <RecoveryView {...props} isSms={recovery?.recoveryType === 'sms'} />
}

export default withRouter(connector(_RecoveryView))